export const MPK_RATING = 'mpkRating';

export const MPK_RATING_ACTIONS_NAME = {
  getMpkActivityDetail: `${MPK_RATING}/getMpkActivityDetail`,
  getLastTwoEventsForExecutiveDiscipline: `${MPK_RATING}/getLastTwoEventsForExecutiveDiscipline`,
};

export const MPK_RATING_MUTATIONS_NAME = {
  setMpkActivityDetail: 'setMpkActivityDetail',
  setLastTwoEventsForExecutiveDiscipline: 'setLastTwoEventsForExecutiveDiscipline'
};

export const MPK_RATING_GETTERS_NAME = {
  getMpkActivityDetail: `${MPK_RATING}/getMpkActivityDetail`,
  getLastTwoEventsForExecutiveDiscipline: `${MPK_RATING}/getLastTwoEventsForExecutiveDiscipline`,
};
